export var PRODUCT_TYPE = {
  rko: 11
};
export var PRODUCT_TYPES = {
  all: 'all',
  fop: 'fop',
  jur: 'jur'
};
export var CLIENT_TYPES = {
  it: 'it'
};
export var ACTIVITY_TYPE_KEYS = {
  it: 'J'
};
export var CheckboxFilters = {
  platforms: {
    mobileBanking: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.clientBankAppIosLink) || !!(el != null && el.clientBankAppAndroidLink);
        });
      }
    },
    internetBanking: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.clientBankWebLink);
        });
      }
    }
  },
  finance: {
    deposits: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.productBusinessDepositsDescription);
        });
      }
    },
    credits: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.productBusinessCreditsDescription);
        });
      }
    }
  },
  account: {
    remoteOpening: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.productAccountOpeningRemote);
        });
      }
    },
    salaryProject: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.productSalaryProjectDescription);
        });
      }
    }
  },
  acquiring: {
    internetAcquiring: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.internetAcquiringAvailable);
        });
      }
    },
    tradeAcquiring: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.tradeAcquiringAvailable);
        });
      }
    }
  },
  additionally: {
    cashCollection: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.productCashCollectionDescription);
        });
      }
    },
    conciergeService: {
      getFiltred: function getFiltred(arr) {
        return arr.filter(function (el) {
          return !!(el != null && el.productConciergeService);
        });
      }
    }
  }
};
export var MonthlyFee = {
  monthlyFee: 'free'
};
export var MaintenanceCost = {
  zero: {
    value: 'free',
    getFiltred: function getFiltred(arr) {
      return arr.filter(function (el) {
        return (el == null ? void 0 : el.monthlyFee) === 0;
      });
    }
  }
};
export var CURRENCIES = {
  uah: 'UAH',
  usd: 'USD',
  eur: 'EUR'
};
export var CURRENCIES_SYMBOLS = {
  uah: '₴',
  usd: '$',
  eur: '€'
};
export var ACTIVITY_TYPE = {
  A: {
    label: 'Сельское хозяйство, лесное хозяйство и рыбное хозяйство',
    value: 'A'
  },
  B: {
    label: 'Добывающая промышленность и разработка карьеров',
    value: 'B'
  },
  C: {
    label: 'Перерабатывающая промышленность',
    value: 'C'
  },
  D: {
    label: 'Поставка электроэнергии, газа, пара и кондиционированного воздуха',
    value: 'D'
  },
  E: {
    label: 'Водоснабжение; канализация, обращение с отходами',
    value: 'E'
  },
  F: {
    label: 'Строительство',
    value: 'F'
  },
  G: {
    label: 'Оптовая и розничная торговля; ремонт автотранспортных средств и мотоциклов',
    value: 'G'
  },
  H: {
    label: 'Транспорт, складское хозяйство, почтовая и курьерская деятельность',
    value: 'H'
  },
  I: {
    label: 'Временное размещение и организация питания',
    value: 'I'
  },
  J: {
    label: 'Информация и телекоммуникации',
    value: 'J'
  },
  K: {
    label: 'Финансовая и страховая деятельность',
    value: 'K'
  },
  L: {
    label: 'Операции с недвижимым имуществом',
    value: 'L'
  },
  M: {
    label: 'Профессиональная, научная и техническая деятельность',
    value: 'M'
  },
  N: {
    label: 'Деятельность в сфере административного и вспомогательного обслуживания',
    value: 'N'
  },
  O: {
    label: 'Государственное управление и оборона; обязательное социальное страхование',
    value: 'O'
  },
  P: {
    label: 'Образование',
    value: 'P'
  },
  Q: {
    label: 'Здравоохранение и оказание социальной помощи',
    value: 'Q'
  },
  R: {
    label: 'Искусство, спорт, развлечения и отдых',
    value: 'R'
  },
  S: {
    label: 'Предоставление других видов услуг',
    value: 'S'
  },
  T: {
    label: 'Деятельность домашних хозяйств',
    value: 'T'
  },
  U: {
    label: 'Деятельность экстерриториальных организаций и органов',
    value: 'U'
  }
};